import { useQuery } from '@tanstack/react-query';
import { useCustomAuth } from '@/contexts/CustomAuthContext';
import { userService } from '@/services/userService';

export interface Subscription {
  id_Subscription?: string;
  Id_Stripe_Product?: string;
  stripe?: { product_id?: string };
  status: string;
}
export interface UserPlanData {
  success: boolean;
  data?: { user?: unknown; sub?: Subscription[]; renewal?: { product_id: string; amount_cents: number; currency: string; plays: number } };
}
export const subscriptionProduct = (sub?: Subscription) => sub?.stripe?.product_id || sub?.Id_Stripe_Product || '';

const useUserPlan = () => {
  const { user } = useCustomAuth();
  const query = useQuery<UserPlanData>({
    queryKey: ['userPlan', user?.id_user],
    queryFn: () => userService.getPlan(user!.id_user),
    enabled: !!user?.id_user,
    staleTime: 0,
    refetchOnMount: 'always',
    retry: 1,
  });
  const subscriptions = query.data?.success ? query.data.data?.sub || [] : [];
  const activeSubscription = subscriptions.find(sub => sub.status === 'active') || subscriptions.find(sub => sub.status === 'trialing');
  const idStripeProduct = subscriptionProduct(activeSubscription);
  const light = [import.meta.env.VITE_PROD_LIGHT, import.meta.env.VITE_PROD_LIGHT87, import.meta.env.VITE_PROD_LIGHT_VSL_DYNAMIC, import.meta.env.VITE_PROD_LIGHT_VSL_DYNAMIC97];
  let plan = '';
  if (idStripeProduct) {
    if (light.includes(idStripeProduct)) plan = 'Light';
    else if (idStripeProduct === import.meta.env.VITE_PROD_PLUS) plan = 'Plus';
    else if (idStripeProduct === import.meta.env.VITE_PROD_PREMIUM) plan = 'Premium';
    else if (idStripeProduct === import.meta.env.VITE_PROD_GIFT) plan = 'Parceiros';
  }
  return {
    plan, idStripeProduct, activeSubscription,
    isTrial: activeSubscription?.status === 'trialing',
    hasSubscriptionHistory: subscriptions.length > 0,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError || query.data?.success === false,
    userPlan: query.data,
    isDynamic97Light: !!idStripeProduct && idStripeProduct === import.meta.env.VITE_PROD_LIGHT_VSL_DYNAMIC97,
  };
};
export default useUserPlan;
